"use strict";

import Common from "../Common";
import CommonGame from "../CommonGame";
import PalettePanel from "../ui/overlays/PalettePanel";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function FillLayer() {
    PIXI.Container.call(this);


    // Enumerators.
    this.STATE =
    {
        IDLE: 0,
        FILL_ANIM: 1
    };


    // Attributes.
    this._state = this.STATE.IDLE;
    this._paletteItem = null;

    this._colour_c2d = null;
    this._colourCode_c2d = null;
    this._fillAnim_c2d = null;

    this._colourContext = null;
    this._colourCodeContext = null;
    this._fillAnimContext = null;

    this._curColour = null;

    this._outlineImage = new Image();

    // Buffers.
    this._fillAnimLayerData = null;
    this._colourLayerData = null; // Contains the pixel colour for the painted areas (no outline) as they are seen on the screen.
    this._outlineLayerData = null; // Contains the pixel colour for the outline. Its content is not displayed.
    this._colourCodeLayerData = null; // Contains the pixel colour CODE for the painted areas (no outline). Its content is not displayed.
    // The flood fill algorithm implemented uses plain colours, so to make it compatible with textures it is necessary to use this auxiliary buffer.

    // Sprites.
    this._colourLayerSprite = null;
    this._fillAnimLayerSprite = null;
    this._outlineLayerSprite = null;
    this._fillAnimMask = null;

    // Input.
    this._lastInputGlobalPosition = new PIXI.Point();

    // Fill animation.
    this._fillAnimRadius = 0;
    this._fillAnimMaxDeltaX = 0;
    this._fillAnimMaxDeltaY = 0;
    this._textureStartPixelPos = -1; // The pixel position (as an index in colourLayerData ) where the selected texture is applied.

    this._drawPS = null;
}
export default FillLayer;
//module.exports               		= FillLayer;
FillLayer.prototype = Object.create(PIXI.Container.prototype);
FillLayer.prototype.constructor = FillLayer;


//===================================================
//
// Public
//
//===================================================

FillLayer.prototype.init = function () {
    // Canvas.
    this._colour_c2d = document.createElement('canvas');
    this._colour_c2d.width = Common.game.canvas.WIDTH;
    this._colour_c2d.height = Common.game.canvas.HEIGHT;

    this._colourCode_c2d = document.createElement('canvas');
    this._colourCode_c2d.width = Common.game.canvas.WIDTH;
    this._colourCode_c2d.height = Common.game.canvas.HEIGHT;

    this._fillAnim_c2d = document.createElement('canvas');
    this._fillAnim_c2d.width = Common.game.canvas.WIDTH;
    this._fillAnim_c2d.height = Common.game.canvas.HEIGHT;

    // Context.
    this._colourContext = this._colour_c2d.getContext('2d');
    this._colourCodeContext = this._colourCode_c2d.getContext('2d');
    this._fillAnimContext = this._fillAnim_c2d.getContext('2d');

    // Layers.
    // Fill colour.
    this._colourLayerSprite = new PIXI.Sprite(PIXI.Texture.fromCanvas(this._colour_c2d));
    this._colourLayerSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._colourLayerSprite.interactive = true;
    this._colourLayerSprite.click = this._colourLayerSprite.touchend = this._onFillLayer_Click.bind(this);
    this.addChild(this._colourLayerSprite);
    // Fill animation.
    this._fillAnimMask = new PIXI.Graphics();
    this.addChild(this._fillAnimMask);
    this._fillAnimLayerSprite = new PIXI.Sprite(PIXI.Texture.fromCanvas(this._fillAnim_c2d));
    this._fillAnimLayerSprite.anchor = new PIXI.Point(0.5, 0.5);
    this._fillAnimLayerSprite.mask = this._fillAnimMask;
    this.addChild(this._fillAnimLayerSprite);
    // Outline.
    var outlineTexture = PIXI.Texture.fromImage("assets/images/outlines/" + ( CommonGame.selectedGallery == CommonGame.GALLERY_ID_DRAW_IT ? "draw_it/" : "colour_it/" ) + CommonGame.selectedImageId + ".png");
    this._outlineLayerSprite = new PIXI.Sprite(outlineTexture);
    var croppedOutlineTexture = new PIXI.Texture(outlineTexture, new PIXI.Rectangle(outlineTexture.width * 0.5 - Common.game.canvas.WIDTH * 0.5, outlineTexture.height * 0.5 - Common.game.canvas.HEIGHT * 0.5, Common.game.canvas.WIDTH, Common.game.canvas.HEIGHT));
    this._outlineLayerSprite.setTexture(croppedOutlineTexture);

    //this._outlineLayerSprite = new PIXI.Sprite( Common.assets.getTexture( CommonGame.selectedImageId ) );
    this._outlineLayerSprite.anchor = new PIXI.Point(0.5, 0.5);
    this.addChild(this._outlineLayerSprite);

    // Buffers.
    this._colourContext.clearRect(0, 0, this._colour_c2d.width, this._colour_c2d.height);
    // Fill animation.
    this._fillAnimLayerData = this._fillAnimContext.getImageData(0, 0, this._fillAnim_c2d.width, this._fillAnim_c2d.height);
    // Colour.
    this._colourLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
    // Colour code.
    this._colourCodeLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
    // Outline.
    this._outlineImage.src = "assets/images/outlines/" + ( CommonGame.selectedGallery == CommonGame.GALLERY_ID_DRAW_IT ? "draw_it/" : "colour_it/" ) + CommonGame.selectedImageId + ".png";
    this._colourContext.drawImage(
        this._outlineImage,
        this._colourLayerSprite.width * 0.5 - this._outlineImage.width * 0.5 * this._outlineLayerSprite.scale.x,
        this._colourLayerSprite.height * 0.5 - this._outlineImage.height * 0.5 * this._outlineLayerSprite.scale.y,
        this._outlineImage.width * this._outlineLayerSprite.scale.x,
        this._outlineImage.height * this._outlineLayerSprite.scale.y);
    this._outlineLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);

    //this._colourContext.fillStyle = 'white';
    //this._colourContext.fillRect( 0, 0, this._colour_c2d.width, this._colour_c2d.height );

    // TODO: ???
    this._colourContext.clearRect(0, 0, this._colourContext.canvas.width, this._colourContext.canvas.height);

    // Initial empty canvas .
    this._colourContext.clearRect(0, 0, this._colour_c2d.width, this._colour_c2d.height);

    // Default colour.
    this._onColour_Changed(Common.assets.getJSON("config").palettePanel.pages[0][0], 0, 0);

    // Vfx.
    this._drawPS = new PIXI.particles.Emitter(this._outlineLayerSprite, [Common.assets.getTexture("particle_paintfill")], Common.assets.getJSON("fill_ps"));
    this._drawPS.emit = false;
    this._drawPS.emitterLifetime = 0.1;

    // Listen to HUD controls.
    Common.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};

FillLayer.prototype.update = function () {
    // Vfx.
    this._drawPS.update(P3.Timestep.deltaTime);
};

FillLayer.prototype.setEnabled = function (isEnabled) {
    this._colourLayerSprite.interactive = isEnabled;
};

FillLayer.prototype.setLayerData = function (data, colourCodeData) {
    this._colourCodeLayerData = colourCodeData;
    this._colourCodeContext.putImageData(colourCodeData, 0, 0);
    //this._colourCodeLayerData = this._colourCodeContext.getImageData( 0, 0, this._colourCode_c2d.width, this._colourCode_c2d.height );

    this._colourLayerData = data;
    this._colourContext.putImageData(data, 0, 0);


    this._colourLayerSprite.texture.update();
};

FillLayer.prototype.clear = function () {
    this._colourContext.clearRect(0, 0, this._colour_c2d.width, this._colour_c2d.height);
    this._colourLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);

    this._colourCodeLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);


    this._colourLayerSprite.texture.update();
};

FillLayer.prototype.updateContextData = function () {
    this._colourCodeLayerData = this._colourCodeContext.getImageData(0, 0, this._colourCode_c2d.width, this._colourCode_c2d.height);
    this._colourLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
};


//===================================================
//
// Private
//
//===================================================

FillLayer.prototype._fillAt = function (startX, startY) {
    //console.log( "_fillAt :: ini" );

    // Check same colour.
    var pixelIndex = ( startY * this._colour_c2d.width + startX ) * 4;
    var r = this._colourCodeLayerData.data[pixelIndex];
    var g = this._colourCodeLayerData.data[pixelIndex + 1];
    var b = this._colourCodeLayerData.data[pixelIndex + 2];
    var a = this._colourCodeLayerData.data[pixelIndex + 3];

    if (r == this._curColour.colourCode.r
        && g == this._curColour.colourCode.g
        && b == this._curColour.colourCode.b) {
        // Return because trying to fill with the same colour
        //console.log( "same colour!" );

        return;
    }

    // Check outline.
    a = this._outlineLayerData.data[pixelIndex + 3];
    if (a > 0) {
        // Return because clicked outline
        //console.log( "outline!" );

        return;
    }

    // Check dynamic outline.
    a = Common.game.canvas.drawLayer.dynOutlineData.data[pixelIndex + 3];
    if (a > 0) {
        // Return because clicked dyn outline
        //console.log( "dyn outline!" );

        return;
    }


    // Flood fill.
    this._textureStartPixelPos = pixelIndex;
    this._floodFill(startX, startY);


    // Redraw.
    this._colourContext.clearRect(0, 0, this._colourContext.canvas.width, this._colourContext.canvas.height);
    this._colourContext.putImageData(this._colourLayerData, 0, 0);
    //this._colourLayerSprite.texture.update();

    // Filling animation.
    var targetRadius = Math.sqrt(Math.pow(this._fillAnimMaxDeltaX, 2) + Math.pow(this._fillAnimMaxDeltaY, 2));
    TweenMax.to(
        this,
        targetRadius / 600,
        {
            _fillAnimRadius: targetRadius,
            ease: Linear.easeInOut,
            onComplete: function () {
                this._updateFillAnimMask();

                this._fillAnimMaxDeltaX = 0;
                this._fillAnimMaxDeltaY = 0;
                this._fillAnimRadius = 0;
                this._state = this.STATE.IDLE;

                // Update layers and buffers.
                this._colourLayerSprite.texture.update();

                this._fillAnimMask.clear();

                this._fillAnimContext.clearRect(0, 0, this._fillAnim_c2d.width, this._fillAnim_c2d.height);
                this._fillAnimLayerData = this._fillAnimContext.getImageData(0, 0, this._fillAnim_c2d.width, this._fillAnim_c2d.height);
                this._fillAnimLayerSprite.texture.update();
            },
            onCompleteScope: this,
            onUpdate: function () {
                this._updateFillAnimMask();
            },
            onUpdateScope: this
        });

    this._fillAnimContext.putImageData(this._fillAnimLayerData, 0, 0);
    this._fillAnimLayerSprite.texture.update();

    this._state = this.STATE.FILL_ANIM;


    //console.log( "_fillAt :: end" );
};

FillLayer.prototype._floodFill = function (startX, startY) {
    var newPos,
        x,
        y,
        pixelIndex,
        reachLeft,
        reachRight,
        drawingBoundLeft = 0,
        drawingBoundTop = 0,
        drawingBoundRight = Common.game.canvas.WIDTH - 1,
        drawingBoundBottom = Common.game.canvas.HEIGHT - 1,
        pixelStack = [[startX, startY]];

    while (pixelStack.length) {
        newPos = pixelStack.pop();
        x = newPos[0];
        y = newPos[1];

        //console.log( "dx = " + dx );
        var dx = x - startX;
        var dy = y - startY;

        // Update limits for filling animation.
        if (Math.abs(dy) > this._fillAnimMaxDeltaY)
            this._fillAnimMaxDeltaY = Math.abs(dy);
        if (Math.abs(dx) > this._fillAnimMaxDeltaX)
            this._fillAnimMaxDeltaX = Math.abs(dx);

        // Get current pixel index inside image data.
        pixelIndex = ( y * this._colour_c2d.width + x ) * 4;

        // Go up as long as the colour matches and are inside the canvas.
        while (y >= drawingBoundTop && this._isPixelToFill(pixelIndex)) {
            y -= 1;
            pixelIndex -= this._colour_c2d.width * 4;
        }

        pixelIndex += this._colour_c2d.width * 4;
        y += 1;
        reachLeft = false;
        reachRight = false;

        // Go down as long as the colour matches and in inside the canvas.
        while (y <= drawingBoundBottom && this._isPixelToFill(pixelIndex)) {
            this._paintPixel(pixelIndex);

            //console.log( "_floodFill :: pixelIndex = " + pixelIndex );

            if (x > drawingBoundLeft) {
                if (this._isPixelToFill(pixelIndex - 4)) {
                    if (!reachLeft) {
                        // Add pixel to stack
                        pixelStack.push([x - 1, y]);
                        reachLeft = true;
                    }
                }
                else if (reachLeft)
                    reachLeft = false;
            }

            if (x < drawingBoundRight) {
                if (this._isPixelToFill(pixelIndex + 4)) {
                    if (!reachRight) {
                        // Add pixel to stack
                        pixelStack.push([x + 1, y]);
                        reachRight = true;
                    }
                }
                else if (reachRight)
                    reachRight = false;
            }

            y += 1;
            pixelIndex += this._colour_c2d.width * 4;

            // Update limits for filling animation.
            dy = y - startY;
            if (Math.abs(dy) > this._fillAnimMaxDeltaY)
                this._fillAnimMaxDeltaY = Math.abs(dy);
        }
    }
};

FillLayer.prototype._isPixelToFill = function (pixelIndex) {
    var result = true;

    // If given pixel is not part of the outline.
    var r = this._outlineLayerData.data[pixelIndex];
    var g = this._outlineLayerData.data[pixelIndex + 1];
    var b = this._outlineLayerData.data[pixelIndex + 2];
    var a = this._outlineLayerData.data[pixelIndex + 3];

    // TODO: Adjust tolerance as necessary.
    result = a <= 255 * 0.5;

    // If current pixel doesn't match the new colour.
    if (result) {
        r = this._colourCodeLayerData.data[pixelIndex];
        g = this._colourCodeLayerData.data[pixelIndex + 1];
        b = this._colourCodeLayerData.data[pixelIndex + 2];

        result = r != this._curColour.colourCode.r
            || g != this._curColour.colourCode.g
            || b != this._curColour.colourCode.b;
    }

    // TEST: DYN_OUT:
    // If current pixel is not part of the dynamic outline.
    if (result) {
        a = Common.game.canvas.drawLayer.dynOutlineData.data[pixelIndex + 3];
        // TODO: Adjust tolerance as necessary.
        result = a < 255;
    }

    return result;
};

FillLayer.prototype._paintPixel = function (pixelIndex) {
    // Find pixel colour.
    var r, g, b, a;
    if (this._curColour.isTexture) {
        // pixelIndex is not in canvas coordinates, but image data coordinates! Divide by 4 ( r + g + b + a ) to make the conversion.
        var dy = Math.floor(pixelIndex / 4 / this._colour_c2d.width) - Math.floor(this._textureStartPixelPos / 4 / this._colour_c2d.width);
        var dx = Math.floor(pixelIndex / 4 % this._colour_c2d.width) - Math.floor(this._textureStartPixelPos / 4 % this._colour_c2d.width);

        var textureY = dy % this._curColour.data.height;
        if (textureY < 0)
            textureY += this._curColour.data.height;
        var textureX = dx % this._curColour.data.height;
        if (textureX < 0)
            textureX += this._curColour.data.height;
        var basePixelPos = ( this._curColour.data.height * textureY + textureX ) * 4;

        //console.log( "dx,dy = " + dx + " :: " + dy );

        r = this._curColour.data.data[basePixelPos];
        g = this._curColour.data.data[basePixelPos + 1];
        b = this._curColour.data.data[basePixelPos + 2];
        a = this._curColour.data.data[basePixelPos + 3] !== undefined ? this._curColour.data.data[basePixelPos + 3] : 255;
    }
    else {
        r = this._curColour.r;
        g = this._curColour.g;
        b = this._curColour.b;
        a = this._curColour.a !== undefined ? this._curColour.a : 255;
    }

    // Buffers.
    // Colour.
    this._colourLayerData.data[pixelIndex] = r;
    this._colourLayerData.data[pixelIndex + 1] = g;
    this._colourLayerData.data[pixelIndex + 2] = b;
    this._colourLayerData.data[pixelIndex + 3] = a;
    // Filling.
    this._fillAnimLayerData.data[pixelIndex] = r;
    this._fillAnimLayerData.data[pixelIndex + 1] = g;
    this._fillAnimLayerData.data[pixelIndex + 2] = b;
    this._fillAnimLayerData.data[pixelIndex + 3] = a;
    // Colour code.
    this._colourCodeLayerData.data[pixelIndex] = this._curColour.colourCode.r;
    this._colourCodeLayerData.data[pixelIndex + 1] = this._curColour.colourCode.g;
    this._colourCodeLayerData.data[pixelIndex + 2] = this._curColour.colourCode.b;
    this._colourCodeLayerData.data[pixelIndex + 3] = 255;
};

FillLayer.prototype._updateFillAnimMask = function () {
    this._fillAnimMask.clear();
    this._fillAnimMask.beginFill();
    this._fillAnimMask.drawCircle(this._lastInputGlobalPosition.x, this._lastInputGlobalPosition.y, this._fillAnimRadius);
    this._fillAnimMask.endFill();
};


//===================================================
//
// Events
//
//===================================================

FillLayer.prototype.onContext_Changed = function () {
    this._colourLayerSprite.texture.update();
};

FillLayer.prototype._onColour_Changed = function (selection, pageIndex, itemIndex) {
    this._paletteItem = selection;
    if (selection.indexOf("#") == 0) {
        // Colour.
        var rgbColour = Common.hexToRgb(selection);

        this._curColour =
        {
            r: rgbColour.r,
            g: rgbColour.g,
            b: rgbColour.b,
            isTexture: false,
            colourCode: {r: pageIndex, g: itemIndex, b: 1} // { r: 0, g: 0, b: 0 } is reserved to represent no colour code, so make sure to not use it! That's why b: 1.
        };
    }
    else {
        // Texture.
        var texture = Common.assets.getTexture(selection);
        var frame = texture.frame;
        var canvas = document.createElement('canvas');
        canvas.width = frame.width;
        canvas.height = frame.height;
        var context = canvas.getContext('2d');
        context.drawImage(
            texture.baseTexture.source,
            frame.x * Common.main.assetRes,
            frame.y * Common.main.assetRes,
            frame.width * Common.main.assetRes,
            frame.height * Common.main.assetRes,
            0, 0,
            frame.width, frame.height);

        this._curColour =
        {
            data: context.getImageData(0, 0, canvas.width, canvas.height),
            isTexture: true,
            colourCode: {r: pageIndex, g: itemIndex, b: 1} // { r: 0, g: 0, b: 0 } is reserved to represent no colour code, so make sure to not use it! That's why b: 1.
        }
    }
};

FillLayer.prototype._onFillLayer_Click = function (mouseData) {
    if (this._state == this.STATE.FILL_ANIM) return;

    // Undo manager.
    this._colourCodeContext.putImageData(this._colourCodeLayerData, 0, 0);
    Common.game.undoManager.save();


    // Use canvas' left-top corner as origin.
    var localCoordsPosition = mouseData.data.getLocalPosition(this._colourLayerSprite);
    var ctxCoordPosition = new PIXI.Point();
    ctxCoordPosition.x = Math.floor(localCoordsPosition.x + Common.game.canvas.WIDTH * 0.5);
    ctxCoordPosition.y = Math.floor(localCoordsPosition.y + Common.game.canvas.HEIGHT * 0.5);
    //console.log( localCoordsPosition.x + " :: " + localCoordsPosition.y );

    this._fillAt(Math.floor(ctxCoordPosition.x), Math.floor(ctxCoordPosition.y));

    this._lastInputGlobalPosition = new PIXI.Point(
        mouseData.data.global.x - Common.game.scene.x - Common.game.canvas.x,
        mouseData.data.global.y - Common.game.canvas.y);

    // Vfx.
    var rgbColour = {r: 255, g: 255, b: 255};
    if (this._paletteItem.indexOf("#") == 0)
        rgbColour = Common.hexToRgb(this._paletteItem);
    this._drawPS.startColor = [rgbColour.r, rgbColour.g, rgbColour.b];
    this._drawPS.endColor = this._drawPS.startColor;
    this._drawPS.spawnPos = new PIXI.Point(localCoordsPosition.x, localCoordsPosition.y);
    this._drawPS.emit = true;

    // Sfx.
    Common.audio.playSound("sfx_tool_paintpot_fill_use_02");

    // Tutorial.
    Common.game.scene.addTutorialEvent(CommonGame.TUT_EVENT.CANVAS_DRAWN);
};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    FillLayer.prototype,
    "colourContext",
    {
        get: function () {
            return this._colourContext;
        }
    });

Object.defineProperty(
    FillLayer.prototype,
    "colourCodeContext",
    {
        get: function () {
            return this._colourCodeContext;
        }
    });

Object.defineProperty(
    FillLayer.prototype,
    "state",
    {
        get: function () {
            return this._state;
        }
    });

Object.defineProperty(
    FillLayer.prototype,
    "paletteItem",
    {
        get: function () {
            return this._paletteItem;
        }
    });